import React from 'react';

const Form = ({ onSubmit, children }) => {
	return (
		<form
			onSubmit={(e) => onSubmit(e)}
			style={{ margin: '20px', height: '100%' }}
		>
			{children}
		</form>
	);
};

export default Form;
